module.exports = __webpack_public_path__ + "img/company_6_logo.c19bd64.png";